import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSpreadsheet } from '@fortawesome/pro-solid-svg-icons/faFileSpreadsheet';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { getLang } from 'shared/store/selectors/lang.selector';
import { formatFileSize } from '../helpers/upload.utils';
import { FilePicker } from './file-picker';
import styles from './file-row.module.scss';

type FileRowProps = {
  fileName: string;
  fileSize: number;
  isBusy?: boolean;
  onChangeFile?: (file: File) => void;
};

export const FileRow = ({ fileName, fileSize, isBusy = false, onChangeFile }: FileRowProps) => {
  const lang = useSelector(getLang('SETTINGS'));

  return (
    <div className={styles.root}>
      <FontAwesomeIcon
        icon={isBusy ? faSpinner : faFileSpreadsheet}
        spin={isBusy}
        className={styles.icon}
      />
      <div className={styles.details}>
        <span className={styles.name}>{fileName}</span>
        <span className={styles.size}>{formatFileSize(fileSize)}</span>
      </div>
      {onChangeFile && (
        <FilePicker onPick={onChangeFile} disabled={isBusy}>
          <button type="button" className={styles.changeFile} disabled={isBusy}>
            {lang.SHIFTS_CHANGE_FILE}
          </button>
        </FilePicker>
      )}
    </div>
  );
};
